import { render, staticRenderFns } from "./visualization.vue?vue&type=template&id=2372b0bc&scoped=true&"
import script from "./visualization.vue?vue&type=script&lang=js&"
export * from "./visualization.vue?vue&type=script&lang=js&"
import style0 from "./visualization.vue?vue&type=style&index=0&id=2372b0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372b0bc",
  null
  
)

export default component.exports